import { Component, inject, OnInit } from '@angular/core';
import { HelpStore } from '../../../stores/help/help.state';
import { ActivatedRoute, Router } from '@angular/router';
import { AppUtilityService } from '../../../utility/app.utility';
import { RoutingService } from '../../../services/routing.service';
import { PermissionService } from '../../../services/permission.service';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { BaseFormComponent } from '../../molecules/base-form/base-form.component';
import { Help } from '../../../models/help';
import { DividerModule } from 'primeng/divider';
import { FormFieldWrapperComponent } from '../../molecules/form-field-wrapper/form-field-wrapper.component';
import { FormFooterComponent } from '../../molecules/form-footer/form-footer.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { NgIf } from '@angular/common';
import { EditorModule } from 'primeng/editor';
import { PrimeTemplate } from 'primeng/api';
import { keyValidator } from '../../../validators/key.validator';
import { ChipsModule } from 'primeng/chips';

@Component({
  selector: 'app-help-form',
  standalone: true,
  imports: [
    DividerModule,
    FormFieldWrapperComponent,
    FormFooterComponent,
    InputSwitchModule,
    InputTextModule,
    NgIf,
    ReactiveFormsModule,
    EditorModule,
    PrimeTemplate,
    ChipsModule,
  ],
  templateUrl: './help-form.component.html',
  styleUrl: './help-form.component.scss',
})
export class HelpFormComponent
  extends BaseFormComponent<Help>
  implements OnInit
{
  override formInitialized = false;
  readonly store = inject(HelpStore);

  constructor(
    router: Router,
    route: ActivatedRoute,
    appUtilityService: AppUtilityService,
    routingService: RoutingService,
    permissionService: PermissionService,
    confirmationDialogService: ConfirmationDialogService,
    private fb: FormBuilder
  ) {
    super(
      router,
      route,
      appUtilityService,
      routingService,
      permissionService,
      confirmationDialogService
    );
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initializeForm();
  }

  /**
   * Initializes the form with values from the selected item in the store.
   * Form fields are set with default values or the values of the item being edited.
   * Validators are applied to relevant form fields.
   *
   * @return {void} Does not return a value.
   */
  initializeForm(): void {
    this.itemToEdit = this.store.selectedItem();
    this.form = this.fb.group({
      name: [this.itemToEdit?.name || '', Validators.required],
      title: [this.itemToEdit?.title || '', Validators.required],
      key: [
        this.itemToEdit?.key || '',
        keyValidator(this.store.allKeys(), this.itemToEdit?.key),
      ],
      content: [this.itemToEdit?.content || '', Validators.required],
      keywords: [this.itemToEdit?.keywords || ''],
    });
    this.formInitialized = true;
  }

  /**
   * Handles the form submission process by triggering the submit logic.
   *
   * @return {void} Does not return a value.
   */
  onSubmit(): void {
    this.submit();
  }
}
